export default __webpack_public_path__ + "static/media/westfield-direct.inline.16b3e9b4.svg";